(function () {
  var CONTROL_LABELS = ['MANAGE PREFERENCES', 'ACCEPT ALL', 'DECLINE'];
  var candidateSelector = 'a, button, input, select, textarea, [role="button"], [role="link"], [onclick], [tabindex], div, span';
  var nativeFocusableSelector = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var actionableSelector = 'a, button, input, select, textarea, [role="button"], [role="link"], [onclick], [tabindex]';
  var bannerSelector = '#bls_cookie, [id*="shopify-pc"], [class*="shopify-pc"], [data-cookie], [class*="cookie"], [id*="cookie"]';
  var focusClass = 'cookie-consent-a11y-control';
  var observerTimeoutMs = 15000;
  var observer;
  var observerStartedAt = Date.now();
  var normalizeFrame = null;

  function injectFocusStyles() {
    if (document.getElementById('cookie-consent-a11y-styles')) return;

    var style = document.createElement('style');
    style.id = 'cookie-consent-a11y-styles';
    style.textContent = [
      '.cookie-consent-a11y-control:focus:not(:focus-visible) {',
      '  outline: 0 !important;',
      '  outline-offset: 0 !important;',
      '  box-shadow: none !important;',
      '}',
      '.cookie-consent-a11y-control:focus-visible {',
      '  outline: 3px solid #ffffff !important;',
      '  outline-offset: 3px !important;',
      '  box-shadow: 0 0 0 6px #000000 !important;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function isVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function isNativeInteractive(element) {
    return /^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(element.tagName);
  }

  function getActionTarget(element, label) {
    var actionTarget = element.closest(actionableSelector);

    if (actionTarget && isVisible(actionTarget) && normalizeText(actionTarget.textContent) === label) {
      return actionTarget;
    }

    return element;
  }

  function scoreTarget(element) {
    if (isNativeInteractive(element)) return 0;
    if (element.getAttribute('role') === 'button' || element.getAttribute('role') === 'link') return 1;
    if (element.hasAttribute('tabindex')) return 2;
    if (element.hasAttribute('onclick')) return 3;
    return 4;
  }

  function uniqueElements(elements) {
    return elements.filter(function (element, index) {
      return elements.indexOf(element) === index;
    });
  }

  function getSearchRoots() {
    var roots = Array.prototype.slice.call(document.querySelectorAll(bannerSelector)).filter(isVisible);

    if (!roots.length && document.body) {
      roots = [document.body];
    }

    return roots;
  }

  function findControlTarget(label, roots) {
    var candidates = [];

    roots.forEach(function (root) {
      candidates = candidates.concat(
        Array.prototype.filter.call(root.querySelectorAll(candidateSelector), function (element) {
          return isVisible(element) && normalizeText(element.textContent) === label;
        })
      );
    });

    if (!candidates.length) {
      return null;
    }

    var targets = uniqueElements(candidates.map(function (element) {
      return getActionTarget(element, label);
    })).filter(function (element) {
      return isVisible(element) && normalizeText(element.textContent) === label;
    });

    targets.sort(function (a, b) {
      return scoreTarget(a) - scoreTarget(b);
    });

    return targets[0];
  }

  function removeDuplicateFocusTargets(label, target, roots) {
    var candidates = Array.prototype.filter.call(
      roots.reduce(function (all, root) {
        return all.concat(Array.prototype.slice.call(root.querySelectorAll(candidateSelector)));
      }, []),
      function (element) {
        return true;
      }
    );

    candidates.forEach(function (element) {
      if (element === target || isNativeInteractive(element)) return;
      if (normalizeText(element.textContent) !== label) return;
      if (!element.contains(target) && !target.contains(element)) return;

      if (element.getAttribute('tabindex') === '0') {
        element.removeAttribute('tabindex');
      }
    });
  }

  function makeKeyboardOperable(element) {
    element.classList.add(focusClass);

    if (element.getAttribute('tabindex') === '-1' || !element.matches(nativeFocusableSelector)) {
      element.setAttribute('tabindex', '0');
    }

    if (!isNativeInteractive(element) && !element.hasAttribute('role')) {
      element.setAttribute('role', 'button');
    }

    if (element.dataset.cookieConsentA11y === 'true') return;
    element.dataset.cookieConsentA11y = 'true';

    element.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      element.click();
    });
  }

  function normalizeCookieConsentControls() {
    var roots = getSearchRoots();
    var matchedControls = 0;

    CONTROL_LABELS.forEach(function (label) {
      var target = findControlTarget(label, roots);
      if (!target) return;
      matchedControls += 1;
      injectFocusStyles();
      makeKeyboardOperable(target);
      removeDuplicateFocusTargets(label, target, roots);
    });

    if (matchedControls === CONTROL_LABELS.length && observer) {
      observer.disconnect();
      observer = null;
      return;
    }

    if (observer && Date.now() - observerStartedAt >= observerTimeoutMs) {
      observer.disconnect();
      observer = null;
    }
  }

  function scheduleNormalizeCookieConsentControls() {
    if (normalizeFrame !== null) return;

    normalizeFrame = window.requestAnimationFrame(function () {
      normalizeFrame = null;
      normalizeCookieConsentControls();
    });
  }

  function startObserver() {
    if (observer || !document.body) return;

    observerStartedAt = Date.now();
    observer = new MutationObserver(function () {
      scheduleNormalizeCookieConsentControls();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectFocusStyles();
      scheduleNormalizeCookieConsentControls();
      startObserver();
    });
  } else {
    injectFocusStyles();
    scheduleNormalizeCookieConsentControls();
    startObserver();
  }

  window.addEventListener('load', scheduleNormalizeCookieConsentControls, { once: true });
})();
